<script lang="ts" setup>
// @ts-ignore
import { TrackerDataType } from '@scr-npm/nuxt-tracker/dist/runtime/types'
import type { TabLink } from '~/components/tabs/Tabs.vue'
export interface PagesContactsMapProps {
    title?: string
}

const { $t } = useNuxtApp()
const tabLinks = ref<TabLink[]>([
    {
        name: $t('Pobočky'),
    },
    {
        name: $t('Servisy'),
    },
])
const props = defineProps<PagesContactsMapProps>()

</script>
<template>
  <section>
    <Tracker :data="{ position: props.title } as TrackerDataType">
      <BoxHeader
        v-if="props.title"
        :heading="props.title"
        heading-level="h2"
      />
      <Tabs
        :select-on-mobile="false"
        type="primary"
        tabs-id="PagesContactsMap"
        :links="tabLinks"
        :scroll-offset="340"
      >
        <template #tab-panel-0>
          <slot name="offices-alert" />
          <WidgetOfficesMap />
        </template>
        <template #tab-panel-1>
          <slot name="services-alert" />
          <WidgetServicesMap />
        </template>
      </Tabs>
    </Tracker>
  </section>
</template>
